//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectNXObject.js";
import "../Mechatronics/Mechatronics.WebNodeTapeInfoBuilderList.js";
import "../Mechatronics/Mechatronics.WebTapeInfoBuilder.js";
import "../Mechatronics/Mechatronics.ZigzaggedWebTapeInfoBuilder.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[0,"AutoGenerator",1,0],[0,"EnableDefineVolume",1,0],[0,"EnableTape",1,1],[1,"ExitSpeed",0,"Expression",0],[0,"ExtrusionCheck",1,0],[1,"Height",0,"Expression",0],[0,"IgnoreContactCheck",1,0],[1,"Length",0,"Expression",0],[1,"MaterialVolume",0,"Expression",0],[0,"Name",1,0],[1,"NodeBodies",0,"SelectNXObjectList",0],[1,"NodeBody",0,"SelectNXObject",1],[1,"NodeLine",0,"SelectNXObject",0],[0,"Orientation",1,"CoordinateSystem",0],[1,"Radius",0,"Expression",0],[0,"ShapeProperty",1,0],[0,"ShapeType",1,0],[1,"StackThickness1",0,"Expression",1],[1,"StackThickness2",0,"Expression",1],[0,"TapeCSYS",1,"CoordinateSystem",1],[1,"TapeInfoList",0,"Mechatronics.WebNodeTapeInfoBuilderList",0],[0,"TappedObjectType",1,0],[0,"Type",1,0],[1,"WebTapeInfo",0,"Mechatronics.WebTapeInfoBuilder",0],[1,"Width",0,"Expression",0],[1,"WinderThickness",0,"Expression",0],[1,"ZigzaggedWebTapeInfo",0,"Mechatronics.ZigzaggedWebTapeInfoBuilder",0]],[[["partOcc","bCreateRigid","bCreateJoint","bCreateMotor","bCreateSensor","rotateSpeed"],"CreateWindingRollerAssociatedPhysicsObjects",{R_:{resultMessage:''}},6,0],[["partOcc","bCreateRigid","bCreateJoint","bCreateSensor"],"CreatePassiveRollerAssociatedPhysicsObjects",{R_:{resultMessage:''}},4,0],[["partOcc","bCreateRigid","bCreateJoint","bCreateMotor","bCreateSensor","moveSpeed","movePosition"],"CreateZigZagAssociatedPhysicsObjects",{R_:{resultMessage:''}},7,0],[["partOcc","bCreateRigid","bCreateObjectSource","bAddIntoZigzag","selectedZigzag","zigzagSide"],"CreatePlateAssociatedPhysicsObjects",{R_:{resultMessage:''}},6,0]],[]];
SPLM.Mechatronics.WebNodeBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.WebNodeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.WebNodeBuilder.Types = Object.freeze({
    "WindingRoller" : "WindingRoller", "PassiveRoller" : "PassiveRoller", "ZigZag" : "ZigZag", "Plate" : "Plate", "ExtrusionMachine" : "ExtrusionMachine"});

SPLM.Mechatronics.WebNodeBuilder.ZigzagSides = Object.freeze({
    "Left" : "Left", "Right" : "Right"});

SPLM.Mechatronics.WebNodeBuilder.ShapeTypes = Object.freeze({
    "Box" : "Box", "Cylinder" : "Cylinder", "Line" : "Line"});

SPLM.Mechatronics.WebNodeBuilder.ShapeProperties = Object.freeze({
    "Automatic" : "Automatic", "UserDefined" : "UserDefined"});

SPLM.Mechatronics.WebNodeBuilder.TappedObjectTypes = Object.freeze({
    "None" : "None", "WebCutPiece" : "WebCutPiece", "Web" : "Web", "ZigzaggedWeb" : "ZigzaggedWeb"});

export default SPLM;